import React from 'react';

const About: React.FC = () => {
  return (
    <div className="about">
      <section className="about-hero">
        <h1>About Nagoya Investments</h1>
        <p>Your Trusted Partner in Global Investment Solutions</p>
      </section>

      <section className="about-content">
        <div className="about-section">
          <h2>Our Story</h2>
          <p>Founded with a vision to bridge global markets, Nagoya Investments has grown into a leading investment firm specializing in international opportunities.</p>
        </div>

        <div className="about-section">
          <h2>Our Mission</h2>
          <p>To provide innovative investment solutions that create value for our clients while maintaining the highest standards of integrity and professionalism.</p>
        </div>

        <div className="about-section">
          <h2>Our Values</h2>
          <ul>
            <li>Integrity and Transparency</li>
            <li>Client-First Approach</li>
            <li>Innovation and Excellence</li>
            <li>Global Perspective</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default About; 